import React from 'react';

import { dataTestIds, FIRST_FOCUSABLE_MENU_ELEMENT, regulatedSectors } from '../../constants';
import { DescriptiveItem } from '../../DescriptiveItem';
import { DescriptiveItemsContainer } from '../../ExpandedMenus.styles';
import { ExpandedNavItemLayout } from '../../ExpandedNavItemLayout';
import { WhatsNew } from '../../WhatsNew';

export const RegulatedSectors = ({
  closeMenu,
  enableIsolatedCloudChanges,
  enableFedrampChanges,
  focusFirstLinkUnderMenu,
}: {
  closeMenu: () => void;
  enableIsolatedCloudChanges: boolean;
  enableFedrampChanges: boolean;
  focusFirstLinkUnderMenu?: React.RefObject<HTMLAnchorElement>;
}) => {
  const primaryContent = (
    <DescriptiveItemsContainer>
      {regulatedSectors(enableIsolatedCloudChanges, enableFedrampChanges).map(
        (collection, index) => (
          <DescriptiveItem
            id={index === 0 ? FIRST_FOCUSABLE_MENU_ELEMENT : undefined}
            key={collection.id}
            iconUrl={collection.icon}
            name={collection.name}
            description={collection.description}
            href={`/collections/${collection.id}`}
            closeMenu={closeMenu}
            focusFirstLinkUnderMenu={focusFirstLinkUnderMenu}
          />
        )
      )}
    </DescriptiveItemsContainer>
  );

  return (
    <ExpandedNavItemLayout
      dataTestId={dataTestIds.EXPANDABLE_MENU__REGULATED_SECTORS}
      primaryContent={primaryContent}
      secondaryContent={<WhatsNew closeMenu={closeMenu} />}
    />
  );
};
